export enum ESplaceni {
    H = 'H',
    F = 'F',
    V = 'V',
    O = 'O'
}
